import React from "react";
import EventSearchBar from "../EventSearchBar";
import EnhancedSearchBar from "./index";

interface SearchBarWrapperProps {
  placeholder: string;
  isMobile?: boolean;
  enhancedSearchEnabled?: boolean; // Feature flag
  onResultsChange?: (results: any) => void;
  selfieSearchS3Bucket?: string;
}

const SearchBarWrapper: React.FC<SearchBarWrapperProps> = ({
  placeholder,
  isMobile = false,
  enhancedSearchEnabled = false,
  onResultsChange,
  selfieSearchS3Bucket = "geosnapshot-selfie-search"
}) => {
  // If enhanced search is enabled, render the new component
  if (enhancedSearchEnabled) {
    return (
      <EnhancedSearchBar
        placeholder={placeholder}
        isMobile={isMobile}
        enabledForUser={true}
        onResultsChange={onResultsChange}
        selfieSearchS3Bucket={selfieSearchS3Bucket}
      />
    );
  }

  // Otherwise, render the legacy search bar
  return (
    <EventSearchBar
      placeholder={placeholder}
      isMobile={isMobile}
    />
  );
};

export default SearchBarWrapper;